import React from 'react'
import ReactPlayer from "react-player"
import "./DD.css"
const DD = () => {
    return (
        <>
        <br/>
        <br/>
        <br/>
<h1 className="screen">Watch DD Kisan Live</h1>
<div class="screen">
<iframe width="560" height="315" src="https://www.youtube.com/embed/0THVvBJkaSM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
</div>
        </>
    )
}
export default DD